import { useInView } from '@/lib/hooks';
import { cn } from '@/lib/utils';
import { AboutSectionTabEnum } from '@/types/enums';
import Image from 'next/image';
import H3 from '../ui/H3';

export default function AboutSectionTabButton({
    id,
    label,
    imageSrc,
    activeTab,
    onTabClick,
}: {
    id: AboutSectionTabEnum;
    activeTab: string;
    label: string;
    imageSrc: string;
    onTabClick: () => void;
}) {
    const { isInView, elementRef } = useInView();

    return (
        <button
            key={id}
            type="button"
            className={cn(
                'overflow-hidden relative group lg:h-[320px] lg:w-1/4 w-1/2 h-[144px] border border-light-grey transition-all ease-in-out outline-none p-5 lg:p-7',
                activeTab === id && 'bg-light-grey underline',
            )}
            onClick={onTabClick}
            id={id}
        >
            <div
                ref={elementRef}
                className={cn(
                    'relative z-1 flex h-full',
                    id === AboutSectionTabEnum.AboutUs || id === AboutSectionTabEnum.DataSecurity
                        ? 'flex-col items-end'
                        : 'flex-col-reverse',
                )}
            >
                <H3
                    className={cn(
                        'max-lg:text-h5 lg:text-h4 max-2xl:text-h3 py-1 h-full flex',
                        id === AboutSectionTabEnum.AboutUs && 'w-full items-end justify-center',
                        id === AboutSectionTabEnum.QualityAssurance && 'items-end justify-end',
                        id === AboutSectionTabEnum.Q1Supplier && 'items-end',
                    )}
                >
                    {label}
                </H3>
                <Image
                    className={cn(
                        'opacity-0 transition-all ease-in-out duration-2000 max-lg:hidden',
                        isInView && 'opacity-100',
                    )}
                    width={100}
                    height={100}
                    src={imageSrc}
                    alt="Tab logo"
                />
                <Image
                    className={cn(
                        'opacity-0 transition-all ease-in-out duration-2000 hidden max-lg:block',
                        isInView && 'opacity-100',
                    )}
                    width={50}
                    height={50}
                    src={imageSrc}
                    alt="Tab logo"
                />
            </div>
            <div className="h-full w-full bg-light-grey absolute top-0 -left-full transition-all duration-700 group-hover:translate-x-full lg:block hidden ease-in-out" />
        </button>
    );
}
